import React from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

const ISSUE_TYPES = [
  { value: 'discipline_investigation', label: 'Discipline / Investigation' },
  { value: 'safety_concern', label: 'Safety Concern' },
  { value: 'overtime_dispute', label: 'Overtime Dispute' },
  { value: 'scheduling_issue', label: 'Scheduling Issue' },
  { value: 'contract_violation', label: 'Contract Violation' },
  { value: 'harassment_conduct', label: 'Harassment / Conduct' },
  { value: 'weingarten_violation', label: 'Weingarten Violation' },
  { value: 'seniority_dispute', label: 'Seniority Dispute' },
  { value: 'pay_wage_issue', label: 'Pay / Wage Issue' },
  { value: 'injury_near_miss', label: 'Injury / Near Miss' },
  { value: 'other', label: 'Other' },
];

const STATUS_OPTIONS = [
  { value: 'open', label: 'Open', color: '#22c55e' },
  { value: 'monitoring', label: 'Monitoring', color: '#3b82f6' },
  { value: 'steward_review', label: 'Steward Review', color: '#f59e0b' },
  { value: 'grievance_drafted', label: 'Grievance Drafted', color: '#8b5cf6' },
  { value: 'closed', label: 'Closed', color: '#6b7280' },
];

function getToken() {
  return localStorage.getItem('token') || '';
}

function headers(json = true) {
  const h = { Authorization: `Bearer ${getToken()}` };
  if (json) h['Content-Type'] = 'application/json';
  return h;
}

function StatusBadge({ status }) {
  const opt = STATUS_OPTIONS.find(s => s.value === status) || { label: status, color: '#6b7280' };
  return (
    <span className="cl-status-badge" data-testid="case-status-badge"
      style={{ background: `${opt.color}18`, color: opt.color, borderColor: `${opt.color}33` }}>
      {opt.label.replace('_', ' ')}
    </span>
  );
}

function IssueLabel({ type }) {
  const opt = ISSUE_TYPES.find(t => t.value === type) || { label: type };
  return <span className="cl-issue-label">{opt.label}</span>;
}

/**
 * P85 — Recommended next action label based on case status + issue type.
 * Pure UI helper; does not mutate state.
 */
function recommendedAction(c) {
  const status = (c.status || '').toLowerCase();
  if (status === 'closed') return 'Archive · Review';
  if (status === 'grievance_drafted' || status === 'grievance drafted') return 'Submit Step 1';
  if (status === 'steward_review' || status === 'steward review') return 'Review · Approve';
  if (status === 'monitoring') return 'Track Evidence';
  const issue = (c.issue_type || '').toLowerCase();
  if (issue.includes('discipline')) return 'Build Grievance';
  if (issue.includes('overtime'))   return 'Calculate Remedy';
  if (issue.includes('safety'))     return 'Document Conditions';
  if (issue.includes('weingarten')) return 'Capture Statement';
  return 'Build Case';
}

export { API, ISSUE_TYPES, STATUS_OPTIONS, getToken, headers, StatusBadge, IssueLabel, recommendedAction };
